module.exports = __webpack_public_path__ + "static/p1-09d237c6154396c09fb7fa9258ec7525.jpg";